import React, { useEffect, useState } from "react";

import {  useParams } from "react-router-dom";

import Header from "../layout/header";
import useAxios from "../utils/useAxios";
import { useQuery } from "react-query";
import IP from "../variable";

import { useMutation } from "react-query";
import toast from "react-hot-toast";

import { formatTime } from "../utils/formatTime";


import greenPatternFull from '../assets/images/bottom-pattern copy.png'
import greenPatternHalf from '../assets/images/bottom-pattern.png'

const MeetingPage = () => {
    
    let api = useAxios()

    const [bookID, setBookID] = useState(null)
    
    const { id } = useParams();

    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        `meeting-${id}`,
        async () => api.get(`${IP}/company/all-meetings/${id}`),
        { cacheTime: 0 }
    );

    const company = data?.data ?? {}
    const slots = company?.meetings ?? []



    useEffect(() => {
        if (bookID){
            bookMutation.mutate(bookID)
        }
    }, [bookID])

  const sendBook = (id) => {
    return api.post(`/company/register-meeting/${id}`);
  };

  const bookMutation = useMutation(sendBook, {
    onSuccess: (res) => {
      toast.success('Meeting Booked');
      setBookID(null)
      refetch()
    },
    onError: (res) => {
        const message = res?.response?.data?.message ?? 'Something went wrong'
        setBookID(null)
      toast.error(message); // onResponse("Something went wrong", "error");
    },
  });


    return (
        <div className="dashboard-page" style={{position: 'relative'}}>
            <Header isDetailPage={true} companyName={company?.company}/>
            
            <div className="container mt-4">
            
           <div className="table-header">
                    {company?.location}
               </div>
{/* 
                {
                    slots.map((slot) => (
                
               <div className="custom-card" key={slot.id}>
                   <span>
                       {slot?.name ?? '-'}
                   </span>
                           <span className="highlight">
                             {formatTime(slot?.start_time)} - {formatTime(slot?.end_time)}
                           </span>
                   

                    <div className="d-flex flex-column">

                   <span className="d-flex align-items-center">
                    <p style={{marginBottom: '0', fontSize: '1.5rem', marginRight: '5px'}}>
                        {slot?.registration_count}/4
                    </p>
                        
                        <p style={{'fontSize': "0.7rem", marginBottom: 0, display: 'flex', flexDirection: 'column'}}>
                            <span> {slot.registration_count > 1 ? 'Investors': 'Investor'} </span>
                            <span style={{marginTop: "-5px"}} >Going</span>
                        </p>
                    </span>
                    
                    <button disabled={bookMutation.isLoading} onClick={() => setBookID(slot?.id)} className={`book-btn ${slot.registration_count == 4 && 'disabled'}`} style={{ transition: 'all 0.3s ease' }}>
                        <span className="mb-2">
                                    {bookMutation.isLoading && slot?.id === bookID ? 'Booking...' : 'Book'}
                        </span>
                        

                            </button>
                    </div>

               </div>
                    ))
         } */}

{slots.map((slot, index) => {
  const prevSlot = slots[index - 1];

  // Detect a break: gap > 10 minutes between previous slot's end and current slot's start
  const hasBreakBefore = prevSlot?.name == 'Slot 4'

  return (
    <>
      {hasBreakBefore && (



      <div className="custom-card" key={slot.id}>
        <span>Break</span>
        <span className="highlight">
          1:00 PM - 2:00 PM
        </span>

        <div className="d-flex flex-column" style={{visibility:'hidden'}}>
          <span className="d-flex align-items-center">
            <p style={{ marginBottom: '0', fontSize: '1.5rem', marginRight: '5px' }} className="">
              {slot?.registration_count}/4
            </p>
            <p style={{ fontSize: '0.7rem', marginBottom: 0, display: 'flex', flexDirection: 'column' }}>
              <span>{slot.registration_count > 1 ? 'Investors' : 'Investor'}</span>
              <span style={{ marginTop: '-5px' }}>Going</span>
            </p>
          </span>

          <button
            disabled={bookMutation.isLoading}
           
            className={`book-btn ${slot.registration_count == 4 && 'disabled'}`}
            style={{ transition: 'all 0.3s ease' }}
          >
            <span className="mb-2">
              {bookMutation.isLoading && slot?.id === bookID ? 'Booking...' : 'Book'}
            </span>
          </button>
        </div>
      </div>


      )}

      <div className="custom-card" key={slot.id}>
        <span>{slot?.name ?? '-'}</span>
        <span className="highlight">
          {formatTime(slot?.start_time)} - {formatTime(slot?.end_time)}
        </span>

        <div className="d-flex flex-column">
          <span className="d-flex align-items-center">
            <p style={{ marginBottom: '0', fontSize: '1.5rem', marginRight: '5px' }}>
              {slot?.registration_count}/4
            </p>
            <p style={{ fontSize: '0.7rem', marginBottom: 0, display: 'flex', flexDirection: 'column' }}>
              <span>{slot.registration_count > 1 ? 'Investors' : 'Investor'}</span>
              <span style={{ marginTop: '-5px' }}>Going</span>
            </p>
          </span>

          <button
            disabled={bookMutation.isLoading}
            onClick={() => setBookID(slot?.id)}
            className={`book-btn ${slot.registration_count == 4 && 'disabled'}`}
            style={{ transition: 'all 0.3s ease' }}
          >
            <span className="mb-2">
              {bookMutation.isLoading && slot?.id === bookID ? 'Booking...' : 'Book'}
            </span>
          </button>
        </div>
      </div>
    </>
  );
})}
        </div>

         <div className="container">

        <span className="d-none d-sm-block pb-3">
                <div className="row">
                    {/* <div className="col-6 d-flex align-items-center">
                        <span style={{fontWeight: 'bold'}}>Media Partner | <img style={{height: '30px'}} src={mediaPartner} alt="" /></span>
                    </div> */}
                    <div className="d-flex justify-content-end">
                        <img className="green-pattern" src={greenPatternFull} alt="" />
                    </div>
                </div>

                </span>

            <span className="d-block d-sm-none">

                <img className="green-pattern" src={greenPatternHalf} alt="" />
            
                {/* <span style={{position: 'absolute', bottom: 0, left: '10px', marginBottom: '10px', fontWeight: 'bold'}}>Media Partner | <img style={{height: '30px'}} src={mediaPartner} alt="" /></span> */}

            </span>
        </div>
         
        </div>
        
    );
};

export default MeetingPage;
